module.exports = __webpack_public_path__ + "img/gepres-blogs.32ab9e8c.png";